"use client";

interface IconifyIconProps {
  icon: string;
  width?: string | number;
  height?: string | number;
  className?: string;
}

export default function IconifyIcon({ icon, width = "1em", height = "1em", className = "" }: IconifyIconProps) {
  return (
    <span
      className={`iconify ${className}`}
      data-icon={icon}
      data-width={width}
      data-height={height}
      style={{ display: 'inline-block', width, height }}
    />
  );
}